<footer class="tw-footer">
  <div class="tw-footer__meta">© {{ year }} Twist Industries · Belgium</div>
  <div class="tw-footer__links">
    <a href="/changelog">Changelog</a>
    <a href="/status">Status</a>
    <a href="/docs">Docs</a>
    <a href="/support">Support</a>
  </div>
</footer>
